export default __webpack_public_path__ + "static/media/profile-cover.97899245.jpg";